import { useQuery } from '@tanstack/react-query';
import { terminologyApi } from '../api/terminologyApi';
import type { ForbiddenWordSearchParams } from '../types/terminology';

/**
 * GET /api/eraf/terminology/forbidden-words (paged search)
 * queryKey: ['terminology', 'forbidden-words', 'list', params]
 */
export function useForbiddenWords(params: ForbiddenWordSearchParams = {}) {
  return useQuery({
    queryKey: ['terminology', 'forbidden-words', 'list', params],
    queryFn: () => terminologyApi.listForbiddenWords(params),
    staleTime: 15_000,
  });
}
